export const modal = () => {
  /* modal buttons */
  const allModalBtns = document.querySelectorAll(".js-modal-btn");
  const allModalBtnsArr = Array.prototype.slice.call(allModalBtns);
  const body = document.body;

  allModalBtnsArr.forEach((btn) => {
    btn.addEventListener("click", () => {
      const modalId = btn.id.slice(0, -4);
      const modal = document.getElementById(modalId);

      modal.classList.add("is-active");
      body.classList.add("modal-is-active");
    });
  });

  /* modal elements */
  const allModals = document.querySelectorAll(".js-modal");
  const allModalsArr = Array.prototype.slice.call(allModals);

  allModalsArr.forEach((modal) => {
    modal.addEventListener("click", (e) => {
      if (e.target === modal) {
        modal.classList.remove("is-active");
        body.classList.remove("modal-is-active");
      }
    });

    const closeBtn = modal.querySelector(".js-close-modal-btn");
    closeBtn.addEventListener("click", closeModal);
  });

  function closeModal() {
    const activeModal = document.querySelector(".js-modal.is-active");
    activeModal.classList.remove("is-active");
    body.classList.remove("modal-is-active");
  }
};
